var exports = {
  "kL": "ThreadWelcomeSection.module__container___U1BuSE",
  "Kk": "ThreadWelcomeSection.module__icon___U1BuSE",
  "e5": "ThreadWelcomeSection.module__iconGlyph___U1BuSE",
  "R_": "ThreadWelcomeSection.module__heading___U1BuSE",
  "h_": "ThreadWelcomeSection.module__description___U1BuSE",
};

module.exports = exports;
